import { render, staticRenderFns } from "./PeopleListModal.vue?vue&type=template&id=02d41f20"
import script from "./PeopleListModal.vue?vue&type=script&lang=js"
export * from "./PeopleListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports